// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1v0yI","logo":"Header_logo__3T0lc","image":"Header_image__2UhJq","title":"Header_title__3SEjb"};